if (!customElements.get("blog-highlights-slider")) {
  customElements.define(
    "blog-highlights-slider",
    class BlogHighlightsSlider extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          swiper: this.querySelector(".blog-highlights__swiper")
        };
        function updateSlidesOpacity(swiper) {
          for (let i = 0; i < swiper.slides.length; i++) {
            const slide = swiper.slides[i];
            if (
              i >= swiper.activeIndex &&
              i < swiper.activeIndex + swiper.params.slidesPerView - 1
            ) {
              slide.classList.remove("swiper-slide-transparent");
            } else {
              slide.classList.add("swiper-slide-transparent");
            }
          }
        }
        const paginationEl = this.querySelector(".swiper-pagination");
        const swiper = new Swiper(this.elements.swiper, {
          // Optional parameters
          slidesPerView: 1.15,
          spaceBetween: 8,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,

          pagination: {
            el: paginationEl,
            clickable: true
          },
          breakpoints: {
            768: {
              slidesPerView: 2.5,
              slidesOffsetBefore: 80,
              slidesOffsetAfter: 80
            },
            1052: {
              slidesPerView: 3,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0
            }
          },
          on: {
            init: function () {
              updateSlidesOpacity(this);
            },
            slideChangeTransitionStart: function () {
              updateSlidesOpacity(this);
            },
            resize: function () {
              updateSlidesOpacity(this);
            }
          }
        });
      }
    }
  );
}
